import type { ButtonHTMLAttributes, ReactNode } from "react"
import { Icon, type IconName } from "./icons.tsx"

export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger" | "link"
export type ButtonSize = "sm" | "md" | "lg"

export function Button({
  variant = "secondary",
  size = "md",
  icon,
  loading = false,
  block = false,
  children,
  className,
  disabled,
  ...rest
}: {
  variant?: ButtonVariant
  size?: ButtonSize
  icon?: IconName
  loading?: boolean
  /** 폭을 꽉 채운다(로그인 버튼 등). */
  block?: boolean
  children?: ReactNode
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  const classes = ["btn", `btn--${variant}`, `btn--${size}`]
  if (block) classes.push("btn--block")
  if (loading) classes.push("is-loading")
  if (className) classes.push(className)

  return (
    <button
      type="button"
      className={classes.join(" ")}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {icon ? <Icon name={icon} size={size === "lg" ? 20 : 16} /> : null}
      {children ? <span>{children}</span> : null}
    </button>
  )
}

/** 글자 없이 아이콘만. 이름표가 없으면 스크린 리더가 읽을 것이 없으므로 label 을 받는다. */
export function IconButton({
  icon,
  label,
  variant = "ghost",
  size = "md",
  className,
  ...rest
}: {
  icon: IconName
  label: string
  variant?: ButtonVariant
  size?: ButtonSize
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  const classes = ["btn", "btn--icon", `btn--${variant}`, `btn--${size}`]
  if (className) classes.push(className)
  return (
    <button type="button" className={classes.join(" ")} aria-label={label} title={label} {...rest}>
      <Icon name={icon} size={size === "sm" ? 16 : 18} />
    </button>
  )
}
